<template>
    <v-layout row wrap justify-center align-center fill-height register mx-0 my-0>
        <v-flex xs12 register__title>
            <a href="https://wiam.ru">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="30px"
                    height="30px"
                >
                    <path
                        d="M27.391,15.771 C26.469,15.771 25.663,15.287 25.199,14.559 L23.017,14.580 L21.358,14.596 C20.850,14.629 20.345,14.330 20.066,13.884 L19.317,12.683 L14.535,23.158 C14.289,23.699 13.752,24.044 13.165,24.044 C13.143,24.044 13.123,24.044 13.102,24.043 C12.490,24.017 11.954,23.622 11.744,23.042 L9.734,17.462 L7.216,17.462 L5.019,17.462 C4.551,18.169 3.755,18.636 2.849,18.636 C1.408,18.636 0.240,17.458 0.240,16.009 C0.240,14.559 1.408,13.383 2.849,13.383 C3.694,13.383 4.438,13.794 4.913,14.421 L7.174,14.421 L10.793,14.421 C11.429,14.421 11.995,14.822 12.212,15.423 L13.328,18.522 L17.740,8.859 C17.971,8.351 18.459,8.013 19.014,7.976 C19.560,7.940 20.095,8.213 20.390,8.685 L22.174,11.547 L23.070,11.538 L25.358,11.516 C25.836,10.913 26.564,10.518 27.391,10.518 C28.832,10.518 30.000,11.694 30.000,13.145 C30.000,14.595 28.832,15.771 27.391,15.771 ZM25.018,9.172 C22.983,5.518 19.104,3.041 14.655,3.041 C9.350,3.041 4.847,6.562 3.327,11.405 C3.167,11.388 3.012,11.356 2.849,11.356 C1.770,11.356 0.789,11.746 -0.000,12.373 C1.239,5.353 7.332,0.000 14.655,0.000 C20.581,0.000 25.693,3.508 28.091,8.562 C27.861,8.526 27.631,8.491 27.391,8.491 C26.520,8.491 25.714,8.749 25.018,9.172 ZM4.103,20.467 C6.079,24.317 10.062,26.960 14.655,26.960 C20.306,26.960 25.039,22.963 26.234,17.633 C26.607,17.730 26.989,17.799 27.391,17.799 C28.095,17.799 28.755,17.626 29.353,17.341 C28.231,24.502 22.077,30.000 14.655,30.000 C8.213,30.000 2.729,25.854 0.655,20.080 C1.311,20.439 2.051,20.663 2.849,20.663 C3.286,20.663 3.701,20.582 4.103,20.467 Z"
                        fill-rule="evenodd"
                        fill="#ffffff"
                    />
                </svg>
                WIAM
            </a>
        </v-flex>

        <v-flex register__form>
            <h2 class="mb-2">{{$t('registerPage.title')}}</h2>

            <v-tabs v-model="activeTab" grow>
                <v-tab>{{$t('registerPage.tabPhone')}}</v-tab>
                <v-tab>{{$t('registerPage.tabCryptoKey')}}</v-tab>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item class="register__form-tab pt-5">
                        <register-phone
                            :form-data="newUser"
                            :confirm-data="confirmData"
                            v-on:updateForm="updateForm"
                            v-if="!phoneConfirmed"
                        />
                        <register-form
                            :form-data="newUser"
                            :confirm-data="confirmData"
                            v-on:updateForm="updateForm"
                            v-else
                        />
                    </v-tab-item>
                    <v-tab-item class="pt-5 register__form-tab">
                        <template v-if="isCertsEnabled">
                            <v-btn
                                @click="getCerts"
                                color="primary"
                                :loading="isCertsLoading"
                                v-if="!isCertsLoaded"
                            >{{$t('crypto.getCertsSubmit')}}</v-btn>

                            <v-flex
                                xs12
                                v-if="!signConfirmed && isCertsLoaded && certs && certs.length"
                            >
                                <v-layout row wrap v-for="(cert, idx) in certs" :key="idx">
                                    <v-flex @click="getSignCode(cert)" xs12 text-left>
                                        <v-icon size="20px" color="success">verified_user</v-icon>
                                        {{ cert.name }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex
                                xs12
                                register__form-tab--empty
                                v-if="isCertsLoaded && certs && !certs.length"
                            >{{$t('crypto.noCertsList')}}</v-flex>

                            <register-phone
                                :form-data="newUser"
                                :confirm-data="confirmData"
                                v-on:updateForm="updateForm"
                                v-if="!phoneConfirmed && signConfirmed && isCertsLoaded && certs && certs.length"
                            />
                            <register-form
                                :form-data="newUser"
                                :confirm-data="confirmData"
                                v-on:updateForm="updateForm"
                                v-if="phoneConfirmed && signConfirmed && isCertsLoaded && certs && certs.length"
                            />

                            <v-flex xs12 v-if="signErrors">
                                <v-divider />
                                <h3 class="error--text py-3">{{ signErrors }}</h3>
                                <v-divider />
                            </v-flex>
                        </template>
                        <template v-else>
                            <h4 class="error--text py-5">{{$t('crypto.noInstallPlugin')}}</h4>
                        </template>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>

            <p class="mt-4">
                {{$t('registerPage.isRegistred')}}
                <router-link to="/login">{{$t('registerPage.signInLink')}}</router-link>
            </p>

            <loading v-if="disableRegisterForm" />
        </v-flex>
    </v-layout>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import rules from "@/utils/data/rules";
import roles from "@/utils/data/roles";
import RegisterForm from "@/components/register/form";
import RegisterPhone from "@/components/register/phone";

import cryptopro from "crypto-pro";

export default {
    name: "Register",
    data: () => ({
        phoneConfirmed: false,
        signConfirmed: false,
        errors: null,
        errorMessages: {
            full_name: "",
            email: "",
            phone: ""
        },
        disableRegisterForm: false,
        newUser: {
            full_name: "",
            email: "",
            phone: "",
            role: 30,
            password: ""
        },
        confirmData: {
            // signature: null,
            // hash_signature: null,
            // phone_confirm_code: null,
            // hash: null
            // phone: null
            // phoneHash:null
            // result_id
        },

        signErrors: null,
        hash: null,
        certs: null,
        activeCert: null,
        isCertsEnabled: false,
        isCertsLoaded: false,
        isCertsLoading: false,
        signature: null,
        activeTab: null,
        roles,
        rules
    }),
    components: { RegisterForm, RegisterPhone },
    methods: {

        getSysInfo() {
            this.isCertsEnabled = false;
            cryptopro
                .call("getSystemInfo")
                .then(response => {
                    this.sysInfo = response;
                    this.isCertsEnabled = true;
                })
                .catch(error => {
                    this.signErrors = error.message;
                    this.isCertsLoaded = true;
                });
            // .catch(error => console.error(error, "sysInfo error"));
        },
        getCerts() {
            this.certs = [];
            this.isCertsLoaded = false;
            this.isCertsLoading = true;

            cryptopro
                .call("getCertsList")
                .then(list => {
                    if (list && list.length) {
                        list.forEach(cert => {
                            this.certs.push(cert);
                        });
                    }
                    this.isCertsLoaded = true;
                    this.isCertsLoading = false;
                })
                .catch(error => {
                    this.signErrors = error;
                    this.isCertsLoaded = true;
                    this.isCertsLoading = false;
                });
            this.isCertsLoaded = true;
            this.isCertsLoading = false;
        },
        getSignCode(cert) {
            this.disableRegisterForm = true;

            apiCallTrue({
                url: "v1/users/get-sign-code"
            })
                .then(response => {
                    console.log(response, "response code");
                    this.confirmData.hash_signature = response.data.data;
                    this.createSign(cert, response.data.data);
                })
                .catch(error => {
                    // this.errors = error.validation;
                    // this.errorMessages = error.validation;
                    this.errors = error.message;
                    this.disableRegisterForm = false;
                });
        },
        async createSign(cert, hash) {
            const hashBase64 = hash;
            const { thumbprint } = cert;

            await cryptopro
                .call("signData", thumbprint, hashBase64, false)
                .then(signature => {
                    this.confirmData.signature = signature;
                    this.sendHash(signature, hash);
                })
                .catch(error => {
                    console.log(error, "create sign error");
                });
        },
        sendHash(signature, hash) {
            this.disableRegisterForm = true;
            const data = {
                signature,
                hash
            };
            const method = "POST";
            const url = "v1/users/register-sign-check";

            apiCallTrue({
                url,
                method,
                data
            })
                .then(response => {
                    console.log(response, "response send hash");
                    this.signConfirmed = true;
                    this.disableRegisterForm = false;
                })
                .catch(error => {
                    this.signErrors = error.message;
                    this.disableRegisterForm = false;
                });
        },
        updateForm(key, data, regPhone, regPhoneHash, resultId = null) {
            if (!key && !data) return;
            if (key === "confirmDataPhone") {
                this.confirmData.hash = data;
                if(regPhone){
                    this.confirmData.phone = regPhone;
                    this.confirmData.phoneHash = regPhoneHash;
                }
                if(resultId){
                    this.confirmData.result_id = resultId;
                }
                
            } else {
                this[key] = data;
            }
        }
    },
    mounted() {
        this.getSysInfo();
    }
};
</script>

<style lang="scss">
.register {
    background: url(../../assets/images/login.jpg) no-repeat center top;
    background-size: cover;
    position: relative;
    align-content: center;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
    }

    &__title {
        a {
            color: #fff;
            text-align: center;
            font-size: 25px;
            border: 0 !important;
            position: relative;
            margin-bottom: 60px !important;
            letter-spacing: 0.05em;
            display: flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            font-weight: bold;
        }

        svg {
            margin-right: 16px;
        }
    }

    &__form {
        background: #fff;
        box-shadow: 0 0 20px #000;
        border-radius: 4px;
        border: 1px solid #eee;
        padding: 35px 40px 20px !important;
        max-width: 400px;
        text-align: center;
        position: relative;
        z-index: 1;
        max-height: 85%;
        overflow-y: auto;

        p {
            font-size: 0.9em;
            color: #aaa;

            span {
                display: block;

                strong {
                    border-bottom: 1px dashed #aaa;
                    color: #999;
                    font-weight: normal;
                    cursor: pointer;
                }
            }
        }

        .loader {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.85);
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            padding: 0;

            svg {
                width: 70px;
                height: 70px;
                margin: 0;
                display: flex;
                position: static;
            }
        }

        &-accept {
            text-align: left;
            font-size: 12px;
            color: #666;
            font-style: italic;
        }

        &-tab {
            &-name {
                width: calc(50% - 15px);
            }

            &--empty {
                margin: 8px 0 0;
                color: #aaa;
                font-size: 14px;
                font-style: italic;
                padding: 50px 0;
            }
        }
    }

    &__phone {
        max-width: 125px;
    }
}
</style>
